import { Box, Button, CircularProgress, Container} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PaymentAPIService } from "../../services/api";
import { Table, Tag, Input, Space } from 'antd';
import { formatDateTime } from "../../shared/utils";

export default function PaidUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUsers();
  }, []);

  async function fetchUsers() {
    try {
      const res = await PaymentAPIService.getPayments();
      setUsers(res?.data || []);
    } catch (error) {
      console.log(" error", error);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
        <CircularProgress />
      </Box>
    );
  }

  if (users.length === 0) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
        No users found
      </Box>
    );
  }

  const columns = [
    {
      title: "S. No.",
      key: "index",
      render: (_text, _record, index) => index + 1,
      width: "10%",
    },
    {
      title: "Phone",
      dataIndex: 'phone',
      width:"30%",
    },
    {
      title: "Details",
      width:"20%",
      render: (_, { amount }) => (
        <Button>View Payments</Button>
      ),
    }
  ];

  return (
    <Container>
      <h2>Paid users</h2>
      <Table
  className="custom-table"
  columns={columns}
  dataSource={users}
  onRow={(record) => ({
    onClick: () => {
      navigate(`/admin/payments/${record?.phone}/${record?.id}/details`)
    },
  })}
  rowClassName="clickable-row"
/>

    </Container>
  );
}